export default {
    maxVal: 200,
    minVal: 10
}